module.exports = __webpack_public_path__ + "img/131.d8d3c04d.jpg";